var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.21875 8V6C2.21875 5.46957 2.42946 4.96086 2.80454 4.58579C3.17961 4.21071 3.68832 4 4.21875 4H6.21875M2.21875 16V18C2.21875 18.5304 2.42946 19.0391 2.80454 19.4142C3.17961 19.7893 3.68832 20 4.21875 20H6.21875M14.2188 4H16.2188C16.7492 4 17.2579 4.21071 17.633 4.58579C18.008 4.96086 18.2188 5.46957 18.2188 6V8M14.2188 20H16.2188C16.7492 20 17.2579 19.7893 17.633 19.4142C18.008 19.0391 18.2188 18.5304 18.2188 18V16M8.21875 11V9C8.21875 8.46957 8.42946 7.96086 8.80454 7.58579C9.17961 7.21071 9.68832 7 10.2188 7C10.7492 7 11.2579 7.21071 11.633 7.58579C12.008 7.96086 12.2188 8.46957 12.2188 9V11M6.21875 12C6.21875 11.7348 6.32411 11.4804 6.51164 11.2929C6.69918 11.1054 6.95353 11 7.21875 11H13.2188C13.484 11 13.7383 11.1054 13.9259 11.2929C14.1134 11.4804 14.2188 11.7348 14.2188 12V15C14.2188 15.2652 14.1134 15.5196 13.9259 15.7071C13.7383 15.8946 13.484 16 13.2188 16H7.21875C6.95353 16 6.69918 15.8946 6.51164 15.7071C6.32411 15.5196 6.21875 15.2652 6.21875 15V12Z",
    stroke: "#555555",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockAccess);
export default __webpack_public_path__ + "static/media/lock-access.382a934734d03bfdcff2d3a03da3490b.svg";
export { ForwardRef as ReactComponent };